import { apiGet, apiPost } from '../client';
import type { Alert } from '@/types/api';

export function listAlerts(limit = 100): Promise<Alert[]> {
  return apiGet<Alert[]>('/alerts', { query: { limit } });
}

export interface ResendAccepted {
  message: string;
  crash_event_id: number;
}

/**
 * Emergency responders and administrators only. Returns 202 — the work happens in a
 * Celery task, so the outcome shows up by re-reading /alerts, not in this response.
 * Idempotent: targets already marked `sent` are skipped, so this cannot double-call
 * a number that already answered.
 */
export function resendAlerts(crashEventId: number): Promise<ResendAccepted> {
  return apiPost<ResendAccepted>('/alerts/send', { query: { crash_event_id: crashEventId } });
}
